import Vue from 'vue'
import Router from 'vue-router'
import sLogin from '../components/sLogin.vue'
import NewsList from '../components/NewsList.vue'
import NewsDetail from '../components/NewsDetail.vue'
import aLogin from '../components/aLogin.vue'
import AdminTop from '../components/AdminTop.vue'
import AdminNewsList from '../components/AdminNewsList.vue'
import AdminNewsEdit from '../components/AdminNewsEdit.vue'
import AdminNewsEdit2 from '../components/AdminNewsEdit2.vue'
import AdminNewsConfirm from '../components/AdminNewsConfirm.vue'
import AdminNewsConfirm2 from '../components/AdminNewsConfirm2.vue'
import AdminStaffList from '../components/AdminStaffList.vue'
import AdminStaffEdit from '../components/AdminStaffEdit.vue'
import AdminStaffConfirm from '../components/AdminStaffConfirm.vue'
import Index from '../components/index.vue'
import Index2 from '../components/Index2.vue'

import Store from '../store/index.js'

Vue.use(Router)

// export default new Router({
  const routes = [
    {
      path: '/sLogin',
      name: 'sLogin',
      component: sLogin
    },
    {
      path: '/NewsList',
      name: 'NewsList',
      component: NewsList,
      meta: { requiresAuth: true }
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/ubiadmin/AdminLogin',
      name: 'aLogin',
      component: aLogin
    },
    {
      path: '/ubiadmin/AdminTop',
      name: 'AdminTop',
      component: AdminTop,
      meta: { requiresAdminAuth: true }
    },
    {
      path: '/ubiadmin/AdminNewsList',
      name: 'AdminNewsList',
      component: AdminNewsList,
      meta: { requiresAdminAuth: true }
    },
    {
      path: '/ubiadmin/AdminNewsEdit',
      component: Index,
      children: [
        {
          path: '/ubiadmin/AdminNewsEdit',
          name: 'AdminNewsEdit',
          component: AdminNewsEdit,
          meta: { requiresAdminAuth: true }
        },
        {
          path: '/ubiadmin/AdminNewsConfirm',
          name: 'AdminNewsConfirm',
          component: AdminNewsConfirm,
          props: true,
          meta: {
            isConfirm: true,
            requiresAdminAuth: true 
          }
        }
      ]
    },
    {
      path: '/ubiadmin/AdminNewsEdit2',
      component: Index2,
      children: [
        {
          path: '/ubiadmin/AdminNewsEdit2',
          name: 'AdminNewsEdit2',
          component: AdminNewsEdit2,
          meta: { requiresAdminAuth: true }
        },
        {
          path: '/ubiadmin/AdminNewsConfirm2',
          name: 'AdminNewsConfirm2',
          component: AdminNewsConfirm2,
          meta: {
            isConfirm: true,
            requiresAdminAuth: true
          }
        }
      ]
    },
    {
      path: '/ubiadmin/AdminStaffList',
      name: 'AdminStaffList',
      component: AdminStaffList,
      meta: { requiresAdminAuth: true }
    },
    {
      path: '/ubiadmin/AdminStaffEdit',
      name: 'AdminStaffEdit',
      component: AdminStaffEdit,
      meta: { requiresAdminAuth: true }
    },
    {
      path: '/ubiadmin/AdminStaffConfirm',
      name: 'AdminStaffConfirm',
      component: AdminStaffConfirm,
      meta: { requiresAdminAuth: true },
      props: true
    }
  ]
// })

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && Store.state.userToken == '') {
    next({ path: '/sLogin', query: { redirect: to.fullPath } });
  }else if (to.matched.some(record => record.meta.requiresAdminAuth) && Store.state.userToken == ''){
    next({ path: '/ubiadmin/AdminLogin', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js